import { useTranslation } from "react-i18next";

import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";

const filterA5PdfPageSelectionSchema = z.object({
  client_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  page_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  tableau_view_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  tableau_workbook_id_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterA5PdfPageSelectionSchema = z.infer<
  typeof filterA5PdfPageSelectionSchema
>;

const tableName = "a5_pdf_page_selection";
const client = "a5";

export function A5PdfPageSelectionFilter() {
  const { t } = useTranslation("tables");

  const fields: Field[] = [
    {
      name: "client_contains",
      label: t(`${tableName}.searchbox.client_contains`, { defaultValue: "Client" }),
      type: "asyncAutocomplete",
      base_url: "a5/a5_pdf_page_selection",
      column_name: "client",
    },
    {
      name: "page_name_contains",
      label: t(`${tableName}.searchbox.page_name_contains`, { defaultValue: "Page name" }),
      type: "asyncAutocomplete",
      base_url: "a5/a5_pdf_page_selection",
      column_name: "page_name",
    },
    {
      name: "tableau_view_contains",
      label: t(`${tableName}.searchbox.tableau_view_contains`, { defaultValue: "Tableau view" }),
      type: "asyncAutocomplete",
      base_url: "a5/a5_pdf_page_selection",
      column_name: "tableau_view",
    },
    {
      name: "tableau_workbook_id_contains",
      label: t(`${tableName}.searchbox.tableau_workbook_id_contains`, {
        defaultValue: "Tableau workbook ID",
      }),
      type: "asyncAutocomplete",
      base_url: "a5/a5_pdf_page_selection",
      column_name: "tableau_workbook_id",
    },
    {
      name: "created_at",
      type: "dateRange",
      label: t(`${tableName}.searchbox.created_at`, { defaultValue: "Creation date" }),
      from: { name: "created_at_from" },
      to: { name: "created_at_to" },
    },
  ];

  return (
    <FilterTable
      client={client}
      schema={filterA5PdfPageSelectionSchema}
      tableName={tableName}
      fields={fields}
    />
  );
}
